import cn from 'classnames'

interface Props {
    tokenLogo?: string
    networkIcon?: string
    className?: string
    tokenIconSize?: number
    chainIconSize?: number
    isTokenSelector?: boolean
}

const ChainToken: React.FC<Props> = ({
    tokenLogo,
    networkIcon,
    className,
    tokenIconSize = 40,
    chainIconSize = 16,
    isTokenSelector = false,
}: Props) => {
    return (
        <div className={cn('relative flex w-fit items-end p-0.5', className)}>
            <img
                src={tokenLogo}
                className={`rounded-full object-cover`}
                style={{
                    width: `${tokenIconSize}px`,
                    height: `${tokenIconSize}px`,
                    objectFit: 'cover',
                    aspectRatio: '1 / 1',
                    minWidth: `${tokenIconSize}px`,
                    maxWidth: `${tokenIconSize}px`,
                }}
                onError={e => {
                    e.currentTarget.src = '/assets/token/unknown.png'
                }}
            />
            {networkIcon && (
                <div
                    className='absolute rounded-full border border-white bg-mach-button-secondary-background shadow-md'
                    style={{
                        width: isTokenSelector ? `${chainIconSize - 2}px` : `${chainIconSize + 8}px`,
                        height: isTokenSelector ? `${chainIconSize - 2}px` : `${chainIconSize + 8}px`,
                        right: isTokenSelector ? `${2}px` : `-${chainIconSize / 2}px`,
                        bottom: isTokenSelector ? `${2}px` : `-${chainIconSize / 2}px`,
                    }}
                >
                    <img
                        src={networkIcon}
                        className={`h-full w-full rounded-full`}
                        style={{
                            objectFit: 'cover',
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default ChainToken
